import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgendaAdmin from "@/pages/AgendaAdmin";

export const Route = createFileRoute("/agenda/admin")({
  head: () => buildHead({
    title: "Painel da agenda",
    description: "Painel interno do agendador OP2P.",
    path: "/agenda/admin",
    noindex: true,
  }),
  component: AgendaAdmin,
});
